import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface KycSettings {
  bank_details_required: boolean;
  pan_required: boolean;
  aadhaar_required: boolean;
  bank_proof_required: boolean;
  photo_required: boolean;
  kyc_required_for_payout: boolean;
  // True until the owner has saved settings for the first time
  is_default: boolean;
  updated_at: string | null;
  updated_by: string | null;
}

export interface KycSettingsState {
  settings: KycSettings | null;
  loading: boolean;
  saving: boolean;
  error: string | null;
}

const initialState: KycSettingsState = {
  settings: null,
  loading: false,
  saving: false,
  error: null,
};

const kycSettingsSlice = createSlice({
  name: 'kycSettings',
  initialState,
  reducers: {
    setKycSettingsLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setKycSettingsSaving: (state, action: PayloadAction<boolean>) => {
      state.saving = action.payload;
    },
    setKycSettingsError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
    setKycSettings: (state, action: PayloadAction<KycSettings>) => {
      state.settings = action.payload;
    },
  },
});

export const { setKycSettingsLoading, setKycSettingsSaving, setKycSettingsError, setKycSettings } =
  kycSettingsSlice.actions;

export default kycSettingsSlice.reducer;
